import { BeteiligtePartei } from '../../../../generated/model/beteiligte-partei.model';
import { Privatperson } from '../../../../generated/model/privatperson.model';
import { Unternehmen } from '../../../../generated/model/unternehmen.model';

export function isUnternehmen(partei: BeteiligtePartei | null | undefined): partei is Unternehmen {
  return !!partei && 'name' in partei;
}

export function isPrivatperson(partei: BeteiligtePartei | null | undefined): partei is Privatperson {
  return !!partei && !('name' in partei) && ('vorname' in partei || 'nachname' in partei || 'geburtsdatum' in partei);
}
